import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

export const SkeletonTabs = ({
  numberOfTabs,
  className,
  tabClassName
}: {
  numberOfTabs: number
  className?: string
  tabClassName?: string
}) => (
  <Tile className={cn('p-6', 'flex-row', 'gap-4', className)}>
    {Array.from({ length: numberOfTabs }, (_, index) => `tab_${index}`).map(
      (key) => (
        <SkeletonLoader
          key={key}
          className={cn('w-32', 'h-6', 'rounded-sm', tabClassName)}
        />
      )
    )}
  </Tile>
)
